import find from 'lodash/find';
import get from 'lodash/get';
import BaseActionFilter from 'yoda-core-components/lib/helpers/Analytics/BaseActionFilter';
import cookie from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import constants from './Coupon.config';

export const getURLParameterBykey = (key, url = window.location.href) => {
    // TODO - this will moved to Util function later
    let name = key;
    name = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ''));
};

// Page is boolean value, if true, we load page level and we don't set apply method
const createCardRewards = (adjustment, method, bem, page) => {
    const couponRewardItem = {};
    const couponCode = `${adjustment.value}-${constants.TOF}`;
    const description = `${adjustment.description}`;
    couponRewardItem.couponCode = couponCode.toLowerCase();
    couponRewardItem.couponEligible = adjustment.amount ? constants.YES : constants.NO;
    couponRewardItem.couponType = description.toLowerCase();
    couponRewardItem.couponAmount = `${adjustment.amount}`;
    if (adjustment.amount > 0) {
        const discount = find(adjustment.analyticsAttributes, { type: 'couponDiscount' });
        /* istanbul ignore next */
        couponRewardItem.couponDiscount = discount ? discount.value : 0;
    }
    /* istanbul ignore else */
    if (!page) {
        couponRewardItem.couponApplyMethod = `${method}`.toLowerCase();
        couponRewardItem.bem = bem;
    }
    couponRewardItem.rewardRedemptionID = constants.EMPTY;
    couponRewardItem.rewardValid = constants.EMPTY;
    couponRewardItem.rewardType = constants.EMPTY;
    couponRewardItem.rewardAmount = constants.EMPTY;
    couponRewardItem.rewardApplyMethod = constants.EMPTY;
    return couponRewardItem;
};

class CouponActionFilter extends BaseActionFilter {
    // on click of Apply coupon, trigger this function
    static getCouponDL = (store, analyticsEventName = '') => {
        const { isAdjustmentsUpdated, appliedAdjustments } = store.getState();
        const couponRewardsInfo = [];
        const COUPON_APPLIED = 'couponApplied';
        if (appliedAdjustments && appliedAdjustments.length > 0) {
            const adjustment = appliedAdjustments[0];
            let methodValue = '';
            if (isAdjustmentsUpdated.method) {
                methodValue = isAdjustmentsUpdated.method;
            }
            const category = isAdjustmentsUpdated.category || '';
            const couponCode = `${adjustment.value}`;
            const { pageType } = get(window.digitalData, 'page.pageInfo', {});
            const slot = isAdjustmentsUpdated.slot || 0;
            const bem =
                analyticsEventName === COUPON_APPLIED
                    ? `${COUPON_APPLIED}|${category}|slot-${slot}`
                    : `couponRemoved|${couponCode.toLowerCase()}|${pageType}`;
            const result = createCardRewards(adjustment, methodValue, bem, false);
            couponRewardsInfo.push(result);
        }
        const commonDigitalData = {
            cart: {
                couponRewardsInfo,
            },
        };
        return commonDigitalData;
    };

    static getCouponpageDL(store) {
        const state = store.getState();
        let itemsInSaveForLater = 0;
        let expressCheckoutEnabled = 'no';
        const mobileDeviceType = state.context.deviceType.isMobile ? 'mobile' : 'tablet';
        const deviceType = state.context.deviceType.isDesktop ? 'desktop' : mobileDeviceType;
        itemsInSaveForLater = cookie.load('DP_USER_FAVCOUNT');
        const profileAttr = cookie.load('omni_profileAttr') || '';
        const profileAttrArray = profileAttr.split('|');
        /* istanbul ignore if */
        if (profileAttrArray && profileAttrArray.length >= 2) {
            expressCheckoutEnabled = profileAttrArray[0] === 'Y' ? 'yes' : 'no';
        }

        const couponRewardsInfo = [];
        if (state.appliedAdjustments && state.appliedAdjustments.length > 0) {
            state.appliedAdjustments.forEach((adjustment) => {
                /* eslint no-param-reassign: ["error", { "props": false }] */
                adjustment.analyticsAttributes = state.appliedAdjustments.analyticsAttributes;
                const result = createCardRewards(adjustment, '', true);
                couponRewardsInfo.push(result);
            });
        }

        const couponDL = {
            page: {
                category: {
                    subCategory2: '',
                    subCategory1: '',
                    primaryCategory: constants.siteSection.COUPON,
                    department: constants.siteSection.COUPON,
                },
                pageInfo: {
                    // analyticsPageName: 'r:promotions:jcp coupon',
                    pageType: constants.COUPON_PAGE_ID, // home | department | category | gallery | search | pdp | customer service | promotion
                    pageName: constants.COUPON_PAGE_NAME,
                    siteSection: constants.siteSection.COUPON, // home | men | women | for the home | search | gift-card
                    searchRedirect: getURLParameterBykey('redirectTerm') || '',
                    deviceType, // referringURL: document.referrer,
                    releaseVersion: state.context.__RELEASEVERSION__, // eslint-disable-line
                    version: 'yoda coupon 1',
                },
            },
            user: {
                // this will be common for all Micro pages- But we reading info from store, should be there in each micro site
                profile: {
                    profileInfo: {
                        itemsInSaveForLater,
                        expressCheckoutEnabled,
                    },
                },
            },
            cart: {
                couponRewardsInfo,
            },
        };
        return couponDL;
    }

    static getFormErrorData(store) {
        const state = store.getState();
        const error = [];
        state.apiErrorMsgs.map((apiErrorMsg) => {
            const errorInfo = {
                errorDescription: `${constants.TOF}|${apiErrorMsg.errorMessage}`,
                errorId: apiErrorMsg.errorId,
                errorCode: apiErrorMsg.errorCode,
            };
            return error.push(errorInfo);
        });

        const errorDL = {
            error,
        };
        return errorDL;
    }
}

export default CouponActionFilter;
